import { render, staticRenderFns } from "./client-settings.vue?vue&type=template&id=c43eee16"
import script from "./client-settings.vue?vue&type=script&lang=js"
export * from "./client-settings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports